var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconYoutubePlayButton = function SvgIconYoutubePlayButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1200 1200"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C33734",
    d: "M945.825 981.511h-691.65C141.412 981.511 50 890.098 50 777.335v-354.67c0-112.763 91.412-204.175 204.175-204.175h691.65c112.763 0 204.175 91.412 204.175 204.175v354.671c0 112.762-91.412 204.175-204.175 204.175"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M774.74 600 505.469 781.346V418.655z"
  })));
};
export default SvgIconYoutubePlayButton;